export default __webpack_public_path__ + "static/media/lady-fingers.ff17e468.png";